import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Parse a date string (YYYY-MM-DD) from the database as a local date
 * without timezone conversion issues
 */
export function parseDateAsLocal(dateString: string): Date {
  const [year, month, day] = dateString.split('-').map(Number);
  return new Date(year, month - 1, day);
}

/**
 * Format a date object or date string to YYYY-MM-DD for database storage
 * Ensures no timezone shift occurs
 */
export function formatDateForDB(date: Date | string): string {
  if (typeof date === 'string') {
    // If already a string, check if it's in YYYY-MM-DD format
    if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
      return date;
    }
    date = parseDateAsLocal(date);
  }
  
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/**
 * Safely format a date string for display
 * Handles both date strings (YYYY-MM-DD) and timestamp strings
 */
export function formatDateForDisplay(dateString: string | null | undefined): string {
  if (!dateString) return '';
  
  // Check if it's a date-only string (YYYY-MM-DD)
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
    return parseDateAsLocal(dateString).toLocaleDateString();
  }
  
  // Otherwise it's a timestamp, use it directly
  return new Date(dateString).toLocaleDateString();
}
